import "reflect-metadata"
import { injectable } from 'inversify-props';
import { ServiceIPIAdapter } from '@/usecases/impostos/adapter/ServiceIPIAdapter';
import { getIPI, findIPI } from '@/api/impostos';

@injectable()
export class ServiceIPI implements ServiceIPIAdapter {
	get = async (id: string) => await getIPI(id)
	find = async(params: any) => await findIPI(params)
}